import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import i18n from '~/i18n'

export type ThemeType = 'system' | 'light' | 'dark'

const defaultState = {
  language: 'en',
  theme: 'light'
}

export const settingsSlice = createSlice({
  name: 'settings',
  initialState: defaultState,
  reducers: {
    changeLanguage(state, action: PayloadAction<string>) {
      state.language = action.payload
      i18n.changeLanguage(action.payload)
    },
    changeTheme(state, action: PayloadAction<ThemeType>) {
      state.theme = action.payload
    }
  }
})

export const { changeLanguage, changeTheme } = settingsSlice.actions
export { defaultState as settingsDefaultState }
export default settingsSlice.reducer
